import React, { useState, useMemo } from "react";
import clsx from "clsx";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { DebounceInput } from "react-debounce-input";
import { shallowEqual, useSelector } from "react-redux";

import { useHtmlClassService } from "../../../../_core/MetronicLayout";
import { SearchResult } from "./SearchResult";
import { toAbsoluteUrl } from "../../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../../_partials/dropdowns";
import * as requestFromServer from "../../../../../../app/icomos/_redux/churches/churchesCrud";

export function SearchDropdown({ history }) {
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [entities, setEntities] = useState(null);
  const user = useSelector((state) => state.auth.user, shallowEqual);

  const fetchChurches = (queryParams) => {
    return requestFromServer.getAllChurches(queryParams).catch((error) => {
      error.clientMessage = "Can't find churches";
    });
  };

  const handleSearchChange = async (event) => {
    setSearchValue(event.target.value);

    if (event.target.value.length > 2) {
      setLoading(true);

      const serverEntities = await fetchChurches({
        filter: {
          operator: user?.id || null,
          brzoPrebaruvanje: event.target.value,
        },
        sortOrder: "asc",
        sortField: "createdAt",
        pageNumber: 1,
        pageSize: 5,
      });

      setEntities(serverEntities?.data?.entities);
      setLoading(false);
    }
  };

  const clear = () => {
    setEntities(null);
    setSearchValue("");
  };

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.search.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  return (
    <>
      {layoutProps.offcanvas && (
        <div className="topbar-item">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1"
            id="kt_quick_search_toggle"
          >
            <span className="svg-icon svg-icon-xl svg-icon-primary svg-icon-search">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </div>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown
          alignRight
          drop="down"
          onToggle={() => {
            setLoading(false);
            setSearchValue("");
          }}
          id="kt_quick_search_toggle"
        >
          <Dropdown.Toggle as={DropdownTopbarItemToggler}>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="search-panel-tooltip">Брзо пребарување</Tooltip>
              }
            >
              <div className="btn btn-icon btn-hover-transparent-white btn-lg btn-dropdown mr-1">
                <span className="svg-icon  svg-icon-search">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                  />
                </span>
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
            <div
              id="kt_quick_search_dropdown"
              className={clsx("quick-search quick-search-dropdown", {
                "quick-search-has-result": entities && entities.length,
              })}
            >
              <div className="quick-search-form">
                <div className="input-group">
                  <div className={`input-group-prepend`}>
                    <span className="input-group-text">
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Search.svg"
                          )}
                        />
                      </span>
                    </span>
                  </div>
                  <DebounceInput
                    type="text"
                    minLength={2}
                    autoFocus={true}
                    debounceTimeout={300}
                    placeholder="Пребарај..."
                    value={searchValue}
                    onChange={(e) => {
                      handleSearchChange(e);
                    }}
                    className="form-control"
                  />

                  <div
                    className={`input-group-append ${
                      loading ? "spinner spinner-sm spinner-primary" : ""
                    }")}`}
                  >
                    <span className="input-group-text">
                      <i
                        style={{
                          display:
                            loading && searchValue && searchValue.length > 0
                              ? "none"
                              : "flex",
                        }}
                        onClick={clear}
                        className="quick-search-close ki ki-close icon-sm text-muted"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <SearchResult searchValue={searchValue} data={entities} />
            </div>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
